module.exports = __webpack_public_path__ + "static/img/promo (3).b69f307.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/restaurant/promo (3).jpg
// module id = 3U1s
// module chunks = 1